var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSquareEnixLogowine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 800,
    width: 1200,
    viewBox: "-112.20945 -19.5 972.4819 117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97 0c-6.648 0-12 5.352-12 12v45c0 6.648 5.352 12 12 12h16v9h15v-9h17c6.648 0 12-5.352 12-12V12c0-6.648-5.352-12-12-12zm3 12h41v44h-13v-7h-15v7h-13zM14 0C7.352 0 2 5.352 2 12v16c0 6.648 5.352 12 12 12h46v16H0v1c0 6.648 5.352 12 12 12h49c6.648 0 12-5.352 12-12V39c0-6.648-5.352-12-12-12H15V12h43v6h14v-6c0-6.648-5.352-12-12-12zm155 0v57c0 6.648 5.352 12 12 12h43c6.648 0 12-5.352 12-12V0h-15v56h-37V0h-3zm104.5 1L239 69h15l7.625-15h38.75L308 69h15L288.5 1l-.5-1h-14zm7.5 14.781L294.313 42h-26.625zM330 0v69h15V43h9.5l25 26h20l-25-26h7.5c6.648 0 12-5.352 12-12V12c0-6.648-5.352-12-12-12h-40zm15 12h30c2.216 0 4 1.784 4 4v11c0 2.216-1.784 4-4 4h-30zm62-12v69h58V56h-43V12h43V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E20A16",
    d: "M435 27h25v13h-25z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M497 0v69h58V56h-43V12h43V0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E20A16",
    d: "M525 27h25v13h-25z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M567 0v69h14V20.188l36 42.938 1 1.188L621.938 69H632V0h-15v46.438L581 3.5 578.063 0zm77 0h16v69h-16zm23.938 0l30.031 33.344L667.75 69h18l21.5-25.344L730.063 69h18l-32.094-35.656L744.25 0h-18l-19.563 23.063L685.938 0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareEnixLogowine);
export default __webpack_public_path__ + "static/media/Square_Enix-Logo.wine.5ece2eec0a66f5c497697127ecb7dfcb.svg";
export { ForwardRef as ReactComponent };